import { render, staticRenderFns } from "./CancelledRepresentativePlacement.vue?vue&type=template&id=89b1b0c4&"
import script from "./CancelledRepresentativePlacement.vue?vue&type=script&lang=js&"
export * from "./CancelledRepresentativePlacement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports